const { getElement } = window.BAO.Utils

class StoreSelectorDrawer extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.formEl = getElement('#localization_form', { context: this.el })

    if (!this.formEl) return

    this.setupListeners()
  }

  setupListeners () {
    this.handleCountryChange = this.handleCountryChange.bind(this)
    this.handleLanguageChange = this.handleLanguageChange.bind(this)
    this.onTriggerClick = this.onTriggerClick.bind(this)

    this.listeners.add(this.els.countrySelect.element, 'change', (e) => {
      this.handleCountryChange(e)
    })

    this.listeners.add(this.els.languageSelect.element, 'change', (e) => {
      this.handleLanguageChange(e)
    })

    this.listeners.add(this.externalEls.trigger.element, 'click', () => {
      this.onTriggerClick()
    })
  }

  handleCountryChange (e) {
    this.els.countryCode.element.value = e.target.value

    const flagUrl = e.target.options[e.target.selectedIndex].dataset.image

    this.els.countrySelect.element.style.setProperty(
      '--Background_Image',
      `url(${flagUrl})`,
    )
  }

  handleLanguageChange (e) {
    this.els.languageCode.element.value = e.target.value

    const flagUrl = e.target.options[e.target.selectedIndex].dataset.image

    this.els.languageSelect.element.style.setProperty(
      '--Background_Image',
      `url(${flagUrl})`,
    )
  }

  onTriggerClick () {
    this.formEl.submit()
  }

  get userLocationName () {
    return 'BAO-localization-country'
  }
}

if (!customElements.get('store-selector-drawer')) {
  customElements.define('store-selector-drawer', StoreSelectorDrawer)
}
